import { StateSchema } from "@/app/providers/StoreProvider";

export const getAuthIsReady = (state: StateSchema) => state.auth.isReady;
export const getAuthUserData = (state: StateSchema) => state.auth.userData;
